import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  FormControlLabel,
  Input,
  Link,
  Modal,
  Typography,
} from "@mui/material";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../Supporting files/SearchDropdown/SearchDropdown";
import SlidingPanel from "react-sliding-side-panel";
import "../../../../SlideModalOpen.scss";
import DatePicker from "../../../../Supporting files/DatePicker/DatePicker";
import CheckBox from "../../../../Supporting files/CheckBox/CheckBox";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const AddNewEmployee: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [expanded, setExpanded] = React.useState<string | false>("panel1");

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const [pageStatus, setPageStatus] = React.useState<number>(1);

  const [gender, setGender] = React.useState("");
  const [clientfirstname, setClientFirstName] = React.useState("");
  const [clientlastname, setClientLastName] = React.useState("");
  const [clientid, setClientId] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [personalemail, setPersonalEmail] = React.useState("");
  const [companyemail, setCompanyEmail] = React.useState("");
  const [employeeid, setEmployeeId] = React.useState("");
  const [mobilenumber, setMobileNumber] = React.useState("");
  const [department, setDepartment] = React.useState("");
  const [designation, setDesignation] = React.useState("");
  const [policytype, setPolicyType] = React.useState("");
  const [Dob, setDob] = React.useState<Date | null>(null);
  const [Doj, setDoj] = React.useState<Date | null>(null);
  const [policyId, setPolicyId] = React.useState("");
  const [sumInsured, setSumInsured] = React.useState("");
  const [SumInsuredData, setSumInsuredData] = React.useState([
    { label: "", value: "" },
  ]);
  const [pincode, setPincode] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [hnoBuilding, setHnoBuilding] = React.useState("");
  const [locality, setLocality] = React.useState("");
  const [branchLocation, setBranchLocation] = React.useState("");
  const [insurer, setInsurer] = React.useState("");
  const [dependent, setDependent] = React.useState("");
  const [nod, setNod] = React.useState("");
  const [nodData, setNodData] = React.useState([{ label: "", value: "" }]);
  const [dependentType, setdependentType] = React.useState("");

  const policy_type_data = [
    { key: "Group Health Policy", value: "Group Health Policy" },
    { key: "Group Term Insurance", value: "Group Term Insurance" },
    { key: "Group Personal Accident", value: "Group Personal Accident" },
    { key: "Group Critical Illness", value: "Group Critical Illness" },
    { key: "Group Travel Insurance", value: "Group Travel Insurance" },
  ];
  const employee_id_data = [
    { label: "EV 3232", value: "EV 3232" },
    { label: "EV 3233", value: "EV 3233" },
    { label: "EV 3234", value: "EV 3234" },
    { label: "EV 3235", value: "EV 3235" },
    { label: "EV 3236", value: "EV 3236" },
    { label: "EV 3237", value: "EV 3237" },
  ];
  const client_id_data = [
    { label: "CL 0012", value: "CL 0012" },
    { label: "CL 0013", value: "CL 0013" },
    { label: "CL 0014", value: "CL 0014" },
    { label: "CL 0015", value: "CL 0015" },
    { label: "CL 0016", value: "CL 0016" },
    { label: "CL 0017", value: "CL 0017" },
  ];
  const insurer_data = [
    { label: "Reliance", value: "Reliance" },
    { label: "Digit", value: "Digit" },
    { label: "Tata", value: "Tata" },
    { label: "Aditya Birla", value: "Aditya Birla" },
    { label: "Iffco", value: "Iffco" },
  ];
  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
    { label: "New Zealand", value: "New Zealand" },
    { label: " South Africa", value: "South Africa" },
  ];
  const department_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const dependent_data = [
    { key: "Yes", value: "Yes" },
    { key: "No", value: "No" },
  ];
  const dependentTypeData = [
    { key: "Spouse Only", value: "Spouse Only" },
    { key: "Child Only", value: "Child Only" },
    { key: "Parents Only", value: "Parents Only" },
    { key: "Spouse, Child", value: "Spouse, Child" },
    { key: "Spouse, Child, Parents", value: "Spouse, Child, Parents" },
  ];
  const designation_data = [
    {
      label: "Associate Frontend Developer",
      value: "Associate Frontend Developer",
    },
    { label: "Frontend Developer", value: "Frontend Developer" },
    { label: "Senior Frontend Developer", value: "Senior Frontend Developer" },
    {
      label: "Associate Software Engineer",
      value: "Associate Software Engineer",
    },
    { label: "Software Engineer", value: "Software Engineer" },
    { label: "Associate Hr", value: "Associate Hr" },
    { label: "Hr Executive", value: "Hr Executive" },
  ];
  const title_data = [
    { key: "Mr.", value: "Mr." },
    { key: "Mrs.", value: "Mrs." },
    { key: "Ms.", value: "Ms." },
  ];
  const gender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];

  const [addQuoteStep, setAddQuoteStep] = React.useState<
    Array<{ insurer: string; premium: string; deleteable: boolean }>
  >([{ insurer: "", premium: "", deleteable: false }]);

  const [addFeatureStep, setAddFeatureStep] = React.useState<
    Array<{ featureName: string; value: string; deleteable: boolean }>
  >([{ featureName: "", value: "", deleteable: false }]);

  // const [pageStatus, setPageStatus] = React.useState<number>(1);
  async function changePageStatus(status: Boolean) {
    if (status == true) {
      if (pageStatus < 5) {
        setPageStatus(pageStatus + 1);
        if (pageStatus + 1 == 5) {
          value_update(attrName, false);
          setPageStatus(1);
        }
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  }

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };

  const updateMasterStateArray = (attrName: any, value: any) => {
    const array_data = [...addQuoteStep];
    if (attrName[1] === "insurer") {
      array_data[attrName[0]].insurer = value;
    } else if (attrName[1] === "premium") {
      array_data[attrName[0]].premium = value;
    }
    setAddQuoteStep(array_data);
  };

  const updateMasterStateArrays = (attrName: any, value: any) => {
    const array_data = [...addFeatureStep];
    if (attrName[1] === "featureName") {
      array_data[attrName[0]].featureName = value;
    } else if (attrName[1] === "value") {
      array_data[attrName[0]].value = value;
    }
    setAddFeatureStep(array_data);
  };

  const [addCategoryStep, setAddCategoryStep] = useState([
    { category_name: "", description: "", deleteable: false },
  ]);

  var indents = [];
  for (var i = 0; i < addQuoteStep.length; i++) {
    indents.push(<span className="indent" key={i}></span>);
  }

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      panelClassName="slidingPanel"
      backdropClicked={() => value_update(attrName, false)}>
      <div>
        <Grid container spacing={3} alignItems="center">
          <Grid xs={12}>
            <h4 className="mb-0 mt-3 ml-2">Add New Employee</h4>
          </Grid>
          <Grid xs={12}>
            <hr />
          </Grid>
        </Grid>
        <div className="scrollable_area">
          {pageStatus !== 4 ? (
            <Grid container spacing={3}>
              <Grid xs={12}>
                <Accordion
                  expanded={pageStatus === 1}
                  onChange={() => setPageStatus(1)}>
                  <AccordionSummary aria-controls="1-content" id="1-header">
                    <Typography>Company Details</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      <Grid container spacing={3}>
                        <Grid xs={6}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Client ID"
                            value={clientid}
                            attrName={setClientId}
                            value_update={updateMasterState}
                            data={client_id_data}
                            error_message="Please select client ID"
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Employee ID"
                            value={employeeid}
                            attrName={setEmployeeId}
                            value_update={updateMasterState}
                            data={employee_id_data}
                            error_message="Please select Employee ID"
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6}>
                          <SelectDropdown
                            class_name="inputField"
                            title="Title"
                            value={title}
                            attrName={setTitle}
                            value_update={updateMasterState}
                            dropdown_data={title_data}
                            warn_status={false}
                          />
                        </Grid>

                        <Grid xs={6}>
                          <RKTextField
                            class_name="inputField"
                            title="First Name"
                            value={clientfirstname}
                            value_update={updateMasterState}
                            attrName={setClientFirstName}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Last Name"
                            value={clientlastname}
                            value_update={updateMasterState}
                            attrName={setClientLastName}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6}>
                          <SelectDropdown
                            class_name="inputField"
                            title="Gender"
                            value={gender}
                            attrName={setGender}
                            value_update={updateMasterState}
                            dropdown_data={gender_data}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Personal Email"
                            value={personalemail}
                            value_update={updateMasterState}
                            attrName={setPersonalEmail}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Company Email"
                            value={companyemail}
                            value_update={updateMasterState}
                            attrName={setCompanyEmail}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Mobile Number"
                            value={mobilenumber}
                            value_update={updateMasterState}
                            attrName={setMobileNumber}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6}>
                          <DatePicker
                            class_name="inputField"
                            title="Date of Birth"
                            value={Dob}
                            attrName={setDob}
                            value_update={updateMasterState}
                            error_message="Please enter Date of Birth"
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={pageStatus === 2}
                  onChange={() => setPageStatus(2)}>
                  <AccordionSummary aria-controls="2-content" id="2-header">
                    <Typography>Product Details</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      <Grid container spacing={3} alignItems="center">
                        <>
                          <Grid xs={6}>
                            <RKTextField
                              class_name="inputField"
                              title="Policy ID"
                              value={policyId}
                              value_update={updateMasterState}
                              attrName={setPolicyId}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6}>
                            <SelectDropdown
                              class_name="inputField"
                              title="Policy Type"
                              value={policytype}
                              attrName={setPolicyType}
                              value_update={updateMasterState}
                              dropdown_data={policy_type_data}
                              warn_status={false}
                            />
                          </Grid>

                          {policytype === "Group Health Policy" ? (
                            <Grid xs={6}>
                              <SelectDropdown
                                class_name="inputField"
                                title="Dependent"
                                value={dependent}
                                attrName={setDependent}
                                value_update={updateMasterState}
                                dropdown_data={dependent_data}
                                warn_status={false}
                              />
                            </Grid>
                          ) : null}
                          {dependent === "Yes" ? (
                            <>
                              <Grid xs={6}>
                                <SelectDropdown
                                  class_name="inputField"
                                  title="Dependent Type"
                                  value={dependentType}
                                  attrName={setdependentType}
                                  value_update={updateMasterState}
                                  dropdown_data={dependentTypeData}
                                  warn_status={false}
                                />
                              </Grid>
                              <Grid xs={6}>
                                <SearchDropdown
                                  class_name="inputField"
                                  title="NOD"
                                  value={nod}
                                  attrName={setNod}
                                  value_update={updateMasterState}
                                  data={nodData}
                                  error_message="Please select nod"
                                  warn_status={false}
                                />
                              </Grid>
                            </>
                          ) : null}
                          <Grid xs={6}>
                            <SearchDropdown
                              class_name="inputField"
                              title="Insurer"
                              value={insurer}
                              attrName={setInsurer}
                              value_update={updateMasterState}
                              data={insurer_data}
                              error_message="Please select Insurer"
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6}>
                            <SearchDropdown
                              class_name="inputField"
                              title="Sum Insured / Assured"
                              value={sumInsured}
                              attrName={setSumInsured}
                              value_update={updateMasterState}
                              data={SumInsuredData}
                              error_message="Please select sum insured"
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6}>
                            <RKTextField
                              class_name="inputField"
                              title="Branch Location"
                              value={branchLocation}
                              value_update={updateMasterState}
                              attrName={setBranchLocation}
                              warn_status={false}
                            />
                          </Grid>
                        </>
                      </Grid>
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={pageStatus === 3}
                  onChange={() => setPageStatus(3)}>
                  <AccordionSummary aria-controls="3-content" id="3-header">
                    <Typography>Features</Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    <Typography>
                      <Grid container spacing={3} alignItems="center">
                        <Grid xs={4}>
                          <DatePicker
                            class_name="inputField"
                            title="Date of Joining"
                            value={Doj}
                            attrName={setDoj}
                            value_update={updateMasterState}
                            error_message="Please enter Date of Joining"
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={4}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Department"
                            value={department}
                            attrName={setDepartment}
                            value_update={updateMasterState}
                            data={department_data}
                            error_message="Please select Department"
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={4}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Designation"
                            value={designation}
                            attrName={setDesignation}
                            value_update={updateMasterState}
                            data={designation_data}
                            error_message="Please select Department"
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={pageStatus === 4}
                  onChange={() => setPageStatus(4)}>
                  <AccordionSummary aria-controls="4-content" id="4-header">
                    <Typography>Address</Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    <Typography>
                      <Grid container spacing={3} alignItems="center">
                        <Grid xs={4}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Country"
                            value={country}
                            attrName={setCountry}
                            value_update={updateMasterState}
                            data={country_data}
                            error_message="Please select country"
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={4}>
                          <RKTextField
                            class_name="inputField"
                            title={"Pincode"}
                            value={pincode}
                            attrName={setPincode}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={4} className="address">
                          <p>Mohali, Punjab</p>
                        </Grid>
                        <Grid xs={6}>
                          <RKTextField
                            class_name="inputField"
                            title={"H.No. / Building"}
                            value={hnoBuilding}
                            attrName={setHnoBuilding}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} className="inputField">
                          <RKTextField
                            class_name="inputField"
                            title={"Area / Town / Locality"}
                            value={locality}
                            attrName={setLocality}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </Grid>
          ) : null}
          {pageStatus === 4 ? (
            <Grid
              container
              spacing={2}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}>
              <Grid xs={12}>
                <svg
                  className="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52">
                  <circle
                    className="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />
                  <path
                    className="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
                <p className="quote_success text-center">
                  New Employee has been added successfully!
                </p>
              </Grid>
            </Grid>
          ) : null}
        </div>
        {pageStatus !== 4 ? (
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn"
                onClick={() => {
                  setPageStatus(pageStatus + 1);
                }}>
                Submit
              </Button>
            </Grid>
          </Grid>
        ) : null}
        {/* <Grid container spacing={3}>
                <Grid xs={12} className="ctaBtn mt-4">
                    <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => {}}
                    >
                    Submit
                    </Button>
                </Grid>
            </Grid> */}
      </div>
    </SlidingPanel>
  );
};

export default AddNewEmployee;
